var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{attrs:{"rows":"1"},domProps:{"textContent":_vm._s(_vm.internalValue)},on:{"input":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }